export const BFF_ENDPOINT = '/api'
